import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import { SR_API_ACTION_HOUSEHOLD_LISTING_UPLOAD_LEASE_DRAFT } from 'api/actionTypes';

import preventDefaultPropagation from 'client/helpers/preventDefaultPropagation';

import { createFormValidationFn, createInitialValues } from 'client/helpers/formikHelpers';

import withApiState from 'client/helpers/withApiState';
import postWithState from 'client/actions/postWithState';

import SrDarkModal from 'client/components/SrDarkModal';
import SrFormikField from 'client/components/SrFormikField';
import ButtonDeprecated from 'client/components/ButtonDeprecated';
import SrBox from 'client/components/SrBox';
import SrErrorMessage from 'client/components/SrErrorMessage/SrErrorMessage';

const getFormFields = () => [
  {
    id: 'leaseDraftPdfUrl',
    title: 'Upload Lease Draft',
    type: 'file_single',
    properties: {
      fileAccept: 'application/pdf',
      filePath: '/lease-documents/lease-draft-{uuid}/LeaseDraft',
    },
    validations: ['required'],
  },
];

@withApiState({
  uploadLeaseDraftApiState: {
    action: SR_API_ACTION_HOUSEHOLD_LISTING_UPLOAD_LEASE_DRAFT,
  },
})
class SrHouseholdListingUploadDraftLeaseModal extends Component {
  static propTypes = {
    householdId: PropTypes.number.isRequired,
    listingId: PropTypes.number.isRequired,
    leaseDraftPdfUrl: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
  };

  _onSubmitForm = (formValues) => {
    const { householdId, listingId, onClose, dispatch } = this.props;

    dispatch(postWithState, {
      action: SR_API_ACTION_HOUSEHOLD_LISTING_UPLOAD_LEASE_DRAFT,
      payload: {
        householdId,
        listingId,
        leaseDraftPdfUrl: formValues.leaseDraftPdfUrl,
      },
      onSuccess: () => {
        onClose({
          householdId,
          listingId,
        });
      },
    });
  };

  render() {
    const { onClose, uploadLeaseDraftApiState, leaseDraftPdfUrl } = this.props;

    return (
      <SrDarkModal onClose={onClose}>
        <SrBox className="SrHouseholdLeaseModal">
          <SrBox onClick={preventDefaultPropagation} className="SrHouseholdModalContent">
            <Formik
              initialValues={createInitialValues({
                formFields: getFormFields(),
                defaultValues: {
                  leaseDraftPdfUrl: leaseDraftPdfUrl || '',
                },
              })}
              validate={(values) => {
                const formFields = getFormFields();
                return createFormValidationFn(formFields)(values);
              }}
              onSubmit={this._onSubmitForm}
              render={(formikBag) => {
                const formFields = getFormFields();
                return (
                  <Form>
                    <h1 className="SrHouseholdModalTitle">upload lease draft</h1>

                    {formFields.map((formField) => (
                      <SrFormikField
                        key={formField.id}
                        formField={formField}
                        formikBag={formikBag}
                      />
                    ))}
                    <ButtonDeprecated
                      type="submit"
                      onClick={formikBag.handleSubmit}
                      disabled={!formikBag.isValid}
                    >
                      {uploadLeaseDraftApiState.inProgress
                        ? 'please wait...'
                        : 'upload lease draft'}
                    </ButtonDeprecated>
                  </Form>
                );
              }}
            />

            {uploadLeaseDraftApiState.error && (
              <SrBox marginTop="10px" borderRadius="3px" overflow="hidden">
                <SrErrorMessage>{uploadLeaseDraftApiState.error.message}</SrErrorMessage>
              </SrBox>
            )}
          </SrBox>
        </SrBox>
      </SrDarkModal>
    );
  }
}

SrHouseholdListingUploadDraftLeaseModal.displayName = 'SrHouseholdListingUploadDraftLeaseModal';

export default SrHouseholdListingUploadDraftLeaseModal;
